import Model from './Model';

export default class SubAffiliate extends Model {
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'sub-affiliates';
  }
}
